import { Box } from "@mui/material";
import React from "react";

function FilterCard({ children }: { children: React.ReactNode }) {
  return (
    <Box sx={{ paddingX: 3, paddingY: 2, bgcolor: "background.paper" }} className="rounded-lg mt-1 shadow-lg">
      {children}
    </Box>
  );
}

export default FilterCard;
